import React from 'react';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { deleteCalendarConfirmationModalMessages as messages } from '../../CalendarLinks.messages';

const DeleteCalendarConfirmationModal = () => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.accept} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default DeleteCalendarConfirmationModal;
